import { Navigate } from "react-router-dom";

const Settings = () => <Navigate to="/api-keys" replace />;

export default Settings;
